import { httpClient } from '@/services/http/httpClient'

export async function downloadUsersHistory(): Promise<void> {
  await httpClient.post('/users/sessions/access-report')
}
